module.exports = __webpack_public_path__ + "img/fruit_orange.3433216e.png";